import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { ConversationStatus } from '../../services/breakdown-api.js';

@customElement('cp-breakdown-confirm')
export class CpBreakdownConfirm extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: String }) conversationStatus: ConversationStatus = 'active';
  @property({ type: Boolean }) hasMessages = false;
  @property({ type: Boolean }) confirming = false;

  private _onConfirm(): void {
    this.dispatchEvent(new CustomEvent('breakdown-confirmed', {
      bubbles: true,
      composed: true,
    }));
  }

  render() {
    if (!this.hasMessages || this.conversationStatus === 'cancelled') return nothing;

    if (this.conversationStatus === 'completed') {
      return html`
        <div class="cp-breakdown-confirm cp-breakdown-confirm--done">
          <div class="cp-breakdown-confirm__success">
            <span class="cp-breakdown-confirm__success-text">Ziele wurden bestaetigt und gespeichert</span>
          </div>
        </div>
      `;
    }

    return html`
      <div class="cp-breakdown-confirm">
        <p class="cp-breakdown-confirm__hint">
          Wenn du mit den vorgeschlagenen Zielen zufrieden bist, bestaetige sie.
          Du kannst vorher im Chat weiter diskutieren.
        </p>
        <button
          class="cp-breakdown-confirm__btn"
          @click=${this._onConfirm}
          ?disabled=${this.confirming}
        >
          ${this.confirming ? 'Wird bestaetigt...' : 'Ziele bestaetigen'}
        </button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-breakdown-confirm': CpBreakdownConfirm;
  }
}
